import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { Suggestion } from '@components/common/Suggestion'
import { useShopStage } from '@hooks'
import { routing } from '@utils/routing'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import levelUpWithMemberships from '../assets/level-up-with-memberships.png'

export const useMembershipsRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { shopStage, isLoading: isLoadingShopStage } = useShopStage()

  return {
    membershipsRecommendation: {
      // LOGIC: disappears after Memberships are enabled
      id: 'memberships',

      enabled:
        shopStage.stage4 &&
        !dashboardFeatureFlags.memberships.enabled &&
        recommendationsDismiss.memberships.visible,
      isLoading: isLoadingShopStage,
      suggestion: (
        <Suggestion
          title="Level up with Memberships"
          description="Offer members-only perks, rewards, and more."
          buttonLabel="Launch memberships"
          buttonTo={routing.membershipsBeta.self}
          imageUrl={levelUpWithMemberships}
          analytics="launchMemberships"
          onDismiss={createOnDismiss(recommendationsDismiss.memberships.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
